import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { NgScrollbarModule } from 'ngx-scrollbar'

@Component({
  selector: 'gb-presenter-config-sidebar',
  imports: [NgScrollbarModule],
  templateUrl: './gb-presenter-config-sidebar.component.html',
  styleUrl: './gb-presenter-config-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPresenterConfigSidebarComponent {}
